import type { ContractSelection } from './contractSelection';

export type ContractLookupRequest = {
  symbol: string;
  sec_type: string;
};

export type ContractLookupApi = (
  request: ContractLookupRequest,
) => Promise<{ data?: { contracts?: ContractSelection[] } } | null | undefined>;

export type ContractLookupResult = {
  contracts: ContractSelection[];
  error: string | null;
};

/** Run a manual-order contract lookup and normalize empty/error outcomes. */
export const lookupManualOrderContracts = async (
  symbol: string,
  secType: string,
  lookup: ContractLookupApi,
): Promise<ContractLookupResult> => {
  try {
    const response = await lookup({
      symbol: symbol.trim().toUpperCase(),
      sec_type: secType,
    });
    const contracts = response?.data?.contracts || [];
    return {
      contracts,
      error: contracts.length === 0
        ? `No ${secType} contracts found for ${symbol.toUpperCase()}.`
        : null,
    };
  } catch (error) {
    const message = error && typeof error === 'object' && 'message' in error
      ? String(error.message || '')
      : '';
    return {
      contracts: [],
      error: message || 'Contract lookup failed.',
    };
  }
};
